import getLogger from '@ignitesales/logger-es';
import React from 'react';
import NeuroMessage from './NeuroMessage';
import * as PropTypes from 'prop-types';

const logger = getLogger({ component: 'ErrorBoundary' });

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ErrorBoundary caught error', { error, errorInfo });
  }

  reset = () => {
    logger.info('Well buddy, the app has been reset from the error page :-/');
    window.location = '/guide';
  };

  render() {
    const componentClass = 'errorPage';

    if (this.state.hasError) {
      return (
        <div className={componentClass}>
          <div className={`${componentClass}__content`} role="complementary" aria-label="Error Message">
            <NeuroMessage id="errorPage.title" tagName="h2" />
            <NeuroMessage id="errorPage.paragraph" shouldHideIfNotFound={true} tagName="p"/>
          </div>
          <div className={`${componentClass}__actions`}>
            <button className="btn btn-primary" onClick={this.reset}>
              <NeuroMessage id="errorPage.resetBtn" />
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.any,
};

export default ErrorBoundary;
